/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.form-group[_ngcontent-%COMP%]   label[_ngcontent-%COMP%] {\n  margin-top: 10px; }'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRDovaW5ldHB1Yi93d3dyb290L2thaXplbi1uZy9zcmMvYXBwL21vZHVsZXMvZW1wbG95ZWUvcGFnZXMvYWRtaW5pc3RyYXRpdmUtZGl2aXNpb24vc2VsZWN0LWFkbWluaXN0cmF0aXZlLWRpdmlzaW9uL3NlbGVjdC1hZG1pbmlzdHJhdGl2ZS1kaXZpc2lvbi5jb21wb25lbnQuc2Nzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9EOi9pbmV0cHViL3d3d3Jvb3Qva2FpemVuLW5nL3NyYy9hcHAvbW9kdWxlcy9lbXBsb3llZS9wYWdlcy9hZG1pbmlzdHJhdGl2ZS1kaXZpc2lvbi9zZWxlY3QtYWRtaW5pc3RyYXRpdmUtZGl2aXNpb24vc2VsZWN0LWFkbWluaXN0cmF0aXZlLWRpdmlzaW9uLmNvbXBvbmVudC5zY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/$$_gendir/app/modules/employee/pages/administrative-division/select-administrative-division/select-administrative-division.component.scss.shim.ngstyle.ts